<script setup lang="ts">
import { onHide, onLaunch, onShow, onError } from '@dcloudio/uni-app'
import { navigateToInterceptor } from '@/router/interceptor'
import { getRegisterBizUser } from '@/utils/login'
import { LDBridge } from '@/utils/handleBrdge'
import { initNativeEventBridge, registerJsHandler } from '@/utils/nativeBridge'
import { ref, nextTick } from 'vue'




// import { createPromotionSDK } from '@LD/land-ui'
// import { setupRouterCompat } from '@/utils/routerCompat/index'
// createPromotionSDK()

import { writeInviteCode } from '@/api/index'
import { useSceneParams } from '@/composables/useSceneParams'
const { parseScene } = useSceneParams()
// 字体加载状态
//const fontsLoaded = ref(false)

// 字体配置
// const fonts = [
//   {
//     family: 'Alimama ShuHeiTi',
//     source: 'https://lingdi-oss-uat.ld3.xyz/font/Alimama_ShuHeiTi_Bold.ttf',
//   },
//   {
//     family: 'Roboto Condensed',
//     source: 'https://lingdi-oss-uat.ld3.xyz/font/RobotoCondensed-Bold.ttf',
//   },
//   {
//     family: 'Regular',
//     source: 'https://lingdi-oss-uat.ld3.xyz/font/title.ttf',
//   },
//   {
//     family: 'RobotoCondensed-VariableFont_wght',
//     source: 'https://lingdi-oss-uat.ld3.xyz/font/RobotoCondensed-VariableFont_wght.ttf',
//   },
//   {
//     family: 'Morganite-Bohk-3',
//     source: 'https://lingdi-oss-uat.ld3.xyz/font/Morganite-Bohk-3.ttf',
//   },
// ]























// 使用 uni.loadFontFace 加载字体
// const loadFontsWithUni = async (): Promise<boolean> => {
//   try {
//     console.log('开始使用 uni.loadFontFace 加载字体...')

//     const fontPromises = fonts.map((font) => {
//       return new Promise<{ font: string; loaded: boolean }>((resolve) => {
//         // 在 H5 环境下，直接使用 CSS @font-face，跳过 uni.loadFontFace
//
//         console.log(`字体 ${font.family} 使用 CSS @font-face 加载`)
//         resolve({ font: font.family, loaded: true })
//

//













//       })
//     })

//     const results = await Promise.allSettled(fontPromises)
//     const loadedFonts = results.filter(
//       (result) => result.status === 'fulfilled' && result.value.loaded,
//     )

//     console.log(`字体加载结果: ${loadedFonts.length}/${fonts.length} 个字体加载成功`)

//     // 等待一小段时间确保字体应用
//     await new Promise((resolve) => setTimeout(resolve, 200))

//     return loadedFonts.length === fonts.length
//   } catch (error) {
//     console.warn('字体加载过程出错:', error)
//     return false
//   }
// }
/**
 * 将查询字符串格式转换为对象
 * @param str 格式如 'LDID=40&ST=B2C'
 * @returns 对象 { LDID: '40', ST: 'B2C' }
 */
const parseQueryString = (str: string): Record<string, string> => {
  if (!str) return {}
  
  return str.split('&').reduce((obj, pair) => {
    const [key, value] = pair.split('=')
    if (key) {
      obj[decodeURIComponent(key)] = decodeURIComponent(value || '')
    }
    return obj
  }, {} as Record<string, string>)
}

const shareTypeMap = {
  C: 'C2C',
  // B: 'B2C',
}

onError((err) => { 
  console.log('App Error', err)
  console.log('App Error message', err?.message)

  if (err?.message?.includes('text/html')) {
    window?.location.reload()
  }

})

onLaunch(async(options) => {
  console.log('App Launch', options)
  // 冷启动时重置 tabbar 状态为首页
  uni.setStorageSync('app-tabbar-index', 0)
  uni.setStorageSync('app-tabbar-page', '/pages/index/index')






  //uni.setStorageSync('token', '')1


























































  // 在应用启动时就开始字体加载检测

  // setupRouterCompat({
  //     enable: true,
  //     debug: false
  // })
  try {

    let userInfo = await LDBridge.userInfo({})
      console.log('收到原生调用UserInfo:', userInfo)

    if (userInfo.token) {
      uni.removeStorageSync('token')
      uni.setStorageSync('token', userInfo.token)
    }

    if (userInfo.tokenHK) {
      uni.removeStorageSync('tokenHK')
      uni.setStorageSync('tokenHK', userInfo.tokenHK)
    }

    if (userInfo.userKey) {
      uni.removeStorageSync('userKey')
      uni.setStorageSync('userKey', userInfo.userKey)
    }

    let deviceInfo = await LDBridge.getDeviceInfo({})
      console.log('收到原生调用getDeviceInfo:', deviceInfo)
    if (deviceInfo) {
      uni.setStorageSync('deviceInfo', deviceInfo)
      uni.setStorageSync('bottomSafeArea', deviceInfo.bottomMargin)
    }
    await initNativeEventBridge()
    await registerJsHandler('uploadUrl')
    
  } catch (error) {
    console.error('获取用户信息失败:', error)
  }


  
  // const initFonts = async () => {
  //   try {
  //     console.log(new Date().getTime(), '开始加载字体...')

  //     // 使用 uni.loadFontFace 加载字体
  //     const allFontsLoaded = await loadFontsWithUni()

  //     if (allFontsLoaded) {
  //       console.log(new Date().getTime(), '所有字体加载完成')
  //     } else {
  //       console.warn('部分字体加载失败，但继续显示页面')
  //     }

  //     // 设置字体加载完成状态
  //     fontsLoaded.value = true
  //     console.log(new Date().getTime(), '字体加载完成，页面开始渲染')
  //   } catch (error) {
  //     console.warn('字体加载失败，继续显示页面:', error)
  //     fontsLoaded.value = true
  //   }
  // }

  // // 立即执行字体加载检测
  // initFonts()






})
onShow(async (options) => {





























})
onHide(() => {
  console.log('App Hide')
})
</script>

<template>
  <div id="app">
    <!-- 字体加载遮罩 -->
    <!-- <div v-if="!fontsLoaded" class="font-loading-overlay">
      <div class="font-loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">正在加载字体...</div>
      </div>
    </div> -->

    <!-- 主要内容v-show="fontsLoaded" -->
    <div >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* 字体加载遮罩样式 */
.font-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.font-loading-content {
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007aff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.loading-text {
  font-size: 16px;
  color: #666;
  font-family: 'PingFang SC', 'Helvetica Neue', 'Arial', sans-serif;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
